import { render, staticRenderFns } from "./AddService.vue?vue&type=template&id=687a568c&scoped=true&"
import script from "./AddService.vue?vue&type=script&lang=js&"
export * from "./AddService.vue?vue&type=script&lang=js&"
import style0 from "./AddService.vue?vue&type=style&index=0&id=687a568c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687a568c",
  null
  
)

export default component.exports